<template>
  <v-tooltip v-if="rotulo" top>
    <template v-slot:activator="{ on }">
      <v-chip x-small color="red darken-2" text-color="white" v-on="on">
        <v-icon x-small left>{{ icone }}</v-icon>{{ $t('area.riskZone') }}
      </v-chip>
    </template>
    <span>{{ $t('area.riskZoneValidationHint', { zones: rotulo }) }}</span>
  </v-tooltip>
  <span v-else class="grey--text">—</span>
</template>

<script>
import { ICONE_ZONA_RISCO } from "@/utils/areasMapa";

/** Sinalização de Zona de Risco da última validação (não altera o resultado). */
export default {
  name: "ZonaRiscoChip",
  props: {
    /** Rótulo das zonas ("código - nome", ...) vindo de zonas_risco_label. */
    rotulo: { type: String, default: null },
  },
  data: () => ({ icone: ICONE_ZONA_RISCO }),
};
</script>
